export const toggleDrawer = (id) => {
    const drawer = document.getElementById(`${id}__drawer`);
    if (!drawer) {
        return;
    }
    const menu = drawer.querySelector('.hds-o-drawer__menu');
    if (!menu) {
        return;
    }
    const animationStyles = { entrance: '', exit: '' };
    if (drawer.classList.contains('left')) {
        animationStyles.entrance = 'slideInLeft';
        animationStyles.exit = 'slideOutLeft';
    }
    else {
        animationStyles.entrance = 'slideInRight';
        animationStyles.exit = 'slideOutRight';
    }
    if (drawer.classList.contains('hide')) {
        drawer.classList.remove('hide');
        menu.classList.add(animationStyles.entrance);
        document.body.style.position = 'absolute';
        document.body.style.overflow = 'hidden';
        return;
    }
    menu.classList.replace(animationStyles.entrance, animationStyles.exit);
    setTimeout(() => {
        drawer.classList.add('hide');
        document.body.style.position = '';
        document.body.style.overflow = '';
        menu.classList.remove(animationStyles.exit);
    }, 300);
};

//# sourceMappingURL=drawer-utils.js.map
